import type { Layout } from '../../types';

export const checkIfFloating = (layout: Layout) =>
  ['floating', 'floatingBackground'].includes(layout);
